import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ModalCambiarEstadoCbComponent } from './modal-cambiar-estado-cb/modal-cambiar-estado-cb.component';
import { ModalCambiarSucursalCbComponent } from '../modals/modal-cambiar-sucursal-cb/modal-cambiar-sucursal-cb.component';
import { ModalCierreJornadaComponent } from './modal-cierre-jornada/modal-cierre-jornada.component';
import { ApiService } from '../services/api.service';
import { ConductorDTO } from '../../dtos/conductor.dto';
import { GetListaConductoresResponseDTO } from '../../dtos/response/getListaConductores.response.dto';
import { AppMessage } from '../app.message';
import { CommonModule } from '@angular/common';
import { ConductorService } from '../services/conductor.service';
import moment from "moment";
import { KpiDTO } from '../../dtos/kpi.dto';
import { SucursalService } from '../services/sucursal.service';
import { GetKPISGestionConductoresResponseDTO } from '../../dtos/response/getKPISgestionConductores.response.dto';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { CambiarSucursalComponent } from '../modals/cambiar-sucursal/cambiar-sucursal.component';
import { EventService } from '../services/event.service';
import { SucursalDTO } from '../../dtos/sucursal.dto';
import { GetListaSucursalesResponseDTO } from '../../dtos/response/getListaSucursales.response.dto';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { NgSelectModule } from '@ng-select/ng-select';
import { JornadaEnCursoDTO } from '../../dtos/jornadaEnCurso.dto';
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { Subject, Subscription } from 'rxjs';
import { debounceTime, skip } from 'rxjs/operators';
import { EstadosConductorService } from '../services/estadosConductor.service';
import { environment } from '../../environments/environment';
import { PdfDTO } from "../../dtos/pdf.dto";
import { GeneralResponseDTO } from '../../dtos/response/general.response.dto';
import { ModalDeshacerFinalizarJComponent } from './modal-deshacer-finalizar-j/modal-deshacer-finalizar-j.component';
import { ToastrService } from 'ngx-toastr';
import { IMqttMessage } from "ngx-mqtt";
import { ConfigMqttService } from "../services/configMqtt.service";
import { GetDetalleJornadaResponseDTO } from "../../dtos/response/getDetalleJornada.response.dto";
import { GetDetalleConductorResponseDTO } from "../../dtos/response/getDetalleConductor.response.dto";
import { ModalPrintComponent } from '../modals/modal-print/modal-print.component';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-gestion-conductores',
  standalone: true,
  imports: [CommonModule, FormsModule, ProgressbarModule, NgSelectModule, TooltipModule],
  templateUrl: './gestion-conductores.component.html',
  styleUrl: './gestion-conductores.component.scss'
})
export class GestionConductoresComponent implements OnInit, OnDestroy {

  filtroColap: boolean = false;

  public listaConductores: Array<ConductorDTO> = [];
  public modoEstandar: boolean = true;
  public listaKPis: Array<KpiDTO> = [];
  public kpiSelected: KpiDTO;
  private hasNext: boolean = false;
  public desactivarInfiniteScroll: boolean = true;
  public uuids: string = "uuids"
  public horaActual: string = "Cargando";
  public tiemposOperativos: { [uuid: string]: string } = {};
  // public estadoConductor: string = 'Todos';
  // public sucursalConductor: string = 'Todos';
  public mostrarSoloHH: boolean = false;
  public sucDistJornadaActual: boolean = false;
  public sucursalesSelectedNombres: string = '';
  public sucursalesSelectedNombresLargos: string = '';
  public listaSucursales: Array<SucursalDTO> = [];
  // public cantidadPorSucursal: Record<string, number> = {};
  public recarga = 900000;
  public contador: number = 0;
  private intervalReloj: any;
  private sucursalesSub: Subscription;

  /* Filtros de pagina */
  public filtro = "";
  public textoLibre = "";
  public sucursalUuid = ""
  public contratoCodigo = "";
  private pageSize: number = 200;
  private page: number = 0;
  indicadores: boolean = true;
  public intervaloProgressBar: any;
  public procesandoPdf: boolean = false;
  // selectedKpiCode: string = '';

  orderBy: string = 'visibleId';
  orderAsc: boolean = true;

  public textoBusqueda = '';

  // private readonly estadosMap = {
  //   "DISPONIBLE": 'Disponible',
  //   "EN_CURSO": 'En Curso',
  //   "EN_PATIO": 'En Patio',
  //   "EN_DESCANSO": 'En Descanso',
  //   "FUERA_JORNADA": 'Fuera de Jornada',
  //   "NO_DISPONIBLE": 'No Disponible',
  //   "REV_TECNICA": "Rev Técnica"
  // };
  public estadoConductor: Array<string> = [];
  public cantidadEstadoConductor: { [key: string]: number } = {};
  public ESTADOS_GESTION_CONDUCTOR = EstadosConductorService.ESTADOS_GESTION_CONDUCTOR;

  recargas = [
    { label: 'Off', value: 0 },
    { label: '15 minutos', value: 900000 },
  ];

  private busquedaSubject = new Subject<string>();
  private listadoSuscripcionesConductoresMqtt: { [key: string]: Subscription } = {};

  constructor(
    private modalService: BsModalService,
    private apiService: ApiService,
    private conductorSerive: ConductorService,
    private sucursalService: SucursalService,
    private toastr: ToastrService,
    private eventService: EventService,
    private configMqttService: ConfigMqttService,
    private userService: UserService) { }

  ngOnDestroy(): void {
    clearInterval(this.intervaloProgressBar);
    clearInterval(this.intervalReloj);
    this.sucursalesSub?.unsubscribe();
    this.unsubscribeMqtt();
  }

  ngOnInit(): void {
    this.calcularTime()
    this.initSucursalesSeleccionadas();
    this.horaActual = moment().format("HH:mm:ss");
    this.intervalReloj = setInterval(() => {
      this.horaActual = moment().format("HH:mm:ss");
      this.actualizarTiemposOperativos();
    }, 1000);

    this.initSuscripcionesEventos();

    this.busquedaSubject
      .pipe(debounceTime(400))
      .subscribe(valor => {
        this.getListaConductores(true);
      });

    this.initAllDatosWS();

  }

  initSucursalesSeleccionadas(): void {
    this.sucursalesSelectedNombres = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto();
    this.sucursalesSelectedNombresLargos = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto(true);
  }

  onBusquedaChange(valor: string) {
    this.busquedaSubject.next(valor);
  }

  calcularTime() {
    clearInterval(this.intervaloProgressBar);
    if (this.recarga != 0)
      this.initProgressBar();
  }

  initProgressBar() {
    this.contador = this.recarga;
    this.intervaloProgressBar = setInterval(() => {
      this.contador -= 1000;
      if (this.contador < 0) {
        this.initAllDatosWS();
        this.contador = this.recarga;
      }
    }, 1000);
  }

  reload() {
    this.calcularTime();
    this.initAllDatosWS();
  }

  initSuscripcionesEventos() {
    this.sucursalesSub = this.sucursalService.sucursales$.pipe(skip(1)).subscribe(() => {
      this.sucursalesSelectedNombres = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto();
      this.sucursalesSelectedNombresLargos = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto(true);
      this.initAllDatosWS();
    })

    this.eventService.subscribe('CAMBIAR_ESTADO_CONDUCTORES_EVENT', () => {
      this.initAllDatosWS();
    })

    this.eventService.subscribe('FINALIZAR_JORNADA_CONDUCTORES_EVENT', () => {
      this.initAllDatosWS();
    })

    this.eventService.subscribe('CAMBIAR_SUCURSAL_CONDUCTORES_EVENT', () => {
      this.initAllDatosWS();
    })

    this.eventService.subscribe('DESHACER_FINALIZAR_JORNADA_CONDUCTORES_EVENT', () => {
      this.initAllDatosWS();
    })
  }

  changeEstadoConductorFiltro() {
    this.page = 0;
    this.initAllDatosWS();
  }

  initAllDatosWS() {

    if (!this.sucursalService.getSucursalesSeleccionadas() || this.sucursalService.getSucursalesSeleccionadas().length == 0) {
      this.toastr.warning('Debe seleccionar alguna sucursal', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      this.openModalCambiarSucursal();
      return;
    }

    this.getListaSucursales();
    this.getKPISporSeccion();
    this.getListaConductores(true);
  }

  getListaSucursales() {
    this.apiService.getListaSucursales().subscribe(
      (resp) => this.getListaSucursalesSuccess(resp),
      (error) => this.getListaSucursalesError(error)
    );
  }

  getListaSucursalesSuccess(getListaSucursalesResponseDTO: GetListaSucursalesResponseDTO) {
    this.listaSucursales = getListaSucursalesResponseDTO.data;
  }

  getListaSucursalesError(error: HttpErrorResponse) {
    console.log('error get sucursales', error);
  }

  getKPISporSeccion(init: boolean = false) {
    this.apiService.getKPISporSeccion(this.sucursalService.getSucursalesUUIDSeleccionadasComoTexto(), 'GESTION_CONDUCTORES')
      .subscribe((resp) => this.getKPISporSeccionSuccess(resp, init), (error) => this.getKPISporSeccionError(error));
  }

  getKPISporSeccionSuccess(getKPISGestionConductores: GetKPISGestionConductoresResponseDTO, init: boolean) {
    this.listaKPis = getKPISGestionConductores.data;
  }

  getKPISporSeccionError(error: HttpErrorResponse) {
    console.log('error lista viajes', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_LISTA_VIAJES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getListaConductores(init: boolean = false) {
    const codigoKpi = this.kpiSelected ? this.kpiSelected.codigo : '';

    this.apiService.getListaConductoresGestionConductores(
      this.sucursalService.getSucursalesUUIDSeleccionadasComoTexto(),
      // this.selectedKpiCode,
      codigoKpi,
      this.mostrarSoloHH,
      this.sucDistJornadaActual,
      this.page,
      this.pageSize,
      this.orderBy,
      this.orderAsc,
      this.textoBusqueda,
      this.estadoConductor.join(',')
    ).subscribe(
      (resp) => this.getListaConductoresSuccess(resp, init),
      (error) => this.getListaConductoresError(error)
    );
  }

  getListaConductoresSuccess(getListaConductoresResponseDTO: GetListaConductoresResponseDTO, init: boolean) {
    console.log('exito lista conductores', getListaConductoresResponseDTO);
    if (init) {
      this.listaConductores = getListaConductoresResponseDTO.data.list;
    } else {
      this.listaConductores = this.listaConductores.concat(getListaConductoresResponseDTO.data.list);
    }
    this.actualizarTiemposOperativos();
    // this.actualizarCantidades();

    this.hasNext = getListaConductoresResponseDTO.data.hasNext;
    this.initSuscripcionesMqtt();
    if (this.hasNext) {
      this.desactivarInfiniteScroll = false;
      this.page++;
      return;
    }

    this.desactivarInfiniteScroll = true;

    //this.actualizarCantidadEstados();
  }

  getListaConductoresError(error: HttpErrorResponse) {
    console.log('error lista viajes', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_LISTA_CONDUCTORES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  initSuscripcionesMqtt() {
    console.log('init suscripicon mqtt');
    this.listaConductores.forEach((conductor) => {
      if (!this.listadoSuscripcionesConductoresMqtt[conductor.uuid]) {
        this.listadoSuscripcionesConductoresMqtt[conductor.uuid] = this.configMqttService.subscribeTopicConductor(conductor.uuid).subscribe((mqttMessage: IMqttMessage) => {
          const json = JSON.parse(mqttMessage.payload.toString());
          console.log('message mqtt', json.uuid);
          const indice = this.listaConductores.findIndex(conductor => (conductor.uuid === json.uuid) && (conductor.version < json.version));
          if(indice !== -1)
            this.getDetalleConductor(conductor.uuid);
        });
      }
    })
  }

  unsubscribeMqtt() {
    for (let uuid in this.listadoSuscripcionesConductoresMqtt) {
      if (this.listadoSuscripcionesConductoresMqtt[uuid])
        this.listadoSuscripcionesConductoresMqtt[uuid].unsubscribe();
    }
  }

  getDetalleConductor(uuid: string) {
    this.apiService.getDetalleConductor(uuid)
      .subscribe((resp) => this.getDetalleConductorSuccess(resp), (error) => this.getDetalleConductorError(error));
  }

  getDetalleConductorSuccess(getDetalleConductorResponseDTO: GetDetalleConductorResponseDTO) {
    console.log('exito get detalle conductor', getDetalleConductorResponseDTO);
    if (getDetalleConductorResponseDTO.data) {
      const indice = this.listaConductores.findIndex(jornada => jornada.uuid === getDetalleConductorResponseDTO.data.uuid);
      if (indice !== -1) {
        console.log('conductor encontrado y actualizado mqtt', getDetalleConductorResponseDTO.data.uuid);
        this.listaConductores[indice] = getDetalleConductorResponseDTO.data;
        this.actualizarTiemposOperativos();
        this.eventService.publish('CONDUCTOR_ACTUALIZADO_MQTT_EVENT', getDetalleConductorResponseDTO.data);
      }
    }
  }

  getDetalleConductorError(error: HttpErrorResponse) {
    console.log('error get detalle conductor', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_DETALLE_CONDUCTOR_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  // getPrettyEstadoByEstado(codigo: string) {
  //   return this.estadosMap[codigo] || 'Desconocido';
  // }

  getPrettyHorasExtras(horasExtras: boolean) {
    return horasExtras ? "Si" : "No"
  }

  tienePermisoCambiarEstadoCB(): boolean {
    return this.userService.tienePermiso('CONDUCTOR_CAMBIAR_ESTADO');
  }

  tienePermisoCambiarSucursal(): boolean {
    return this.userService.tienePermiso('CONDUCTOR_CAMBIAR_SUCURSAL');
  }

  tienePermisoFinalizarJornada(): boolean {
    return this.userService.tienePermiso('CONDUCTOR_FINALIZAR');
  }

  tienePermisoDeshacerFinJornada(): boolean {
    return this.userService.tienePermiso('CONDUCTOR_DESHACER_FIN_JORNADA');
  }

  tienePermisoImprimirVoucher(): boolean {
    return this.userService.tienePermiso('VOUCHER_COLACION') || this.userService.tienePermiso('VOUCHER_JORNADA');
  }

  cambiarEstadoCB(conductor: ConductorDTO) {
    this.conductorSerive.setConductorSeleccionado(conductor);
    this.modalService.show(ModalCambiarEstadoCbComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        contrato: conductor.tipoContrato,
        estadoFechaInicio: conductor.estadoFechaInicio,
      }
    });
  }

  cambiarSucursal(conductor: ConductorDTO) {
    this.conductorSerive.setConductorSeleccionado(conductor);
    this.modalService.show(ModalCambiarSucursalCbComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs'
    });
  }

  cierreJornada(conductor: ConductorDTO) {
    this.conductorSerive.setConductorSeleccionado(conductor);

    this.modalService.show(ModalCierreJornadaComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        accion: 'PREVIO_CIERRE'
      }
    });
  }

  deshacerFinJornada(conductor) {
    this.modalService.show(ModalDeshacerFinalizarJComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        conductor
      }
    });
  }

  modalImprimirVoucher(conductor: ConductorDTO) {
    this.modalService.show(ModalPrintComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        conductor: conductor,
        from: 'conductores'
      }
    });
  }

  openModalCambiarSucursal() {
    this.modalService.show(CambiarSucursalComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-md'
    });
  }

  onSort(field: string): void {
    if (this.orderBy === field) {
      this.orderAsc = !this.orderAsc;
    } else {
      this.orderBy = field;
      this.orderAsc = true;
    }

    this.initAllDatosWS();
  }

  get getTodos(): number {
    return this.listaKPis
      .filter(kpi => kpi.codigo.startsWith('todos'))
      .reduce((total, kpi) => total + kpi.valor, 0);
  }

  get getDisponibles(): number {
    return this.listaKPis.find(kpi => kpi.codigo === "conductores_disponible")?.valor;
  }

  get getEnRuta(): number {

    return this.listaKPis.find(kpi => kpi.codigo === "conductores_encurso")?.valor;
  }

  get getApoyoPatio(): number {
    return this.listaKPis.find(kpi => kpi.codigo === "conductores_enpatio")?.valor;
  }

  get getColacion(): number {
    return this.listaKPis.find(kpi => kpi.codigo === "conductores_encolacion")?.valor;
  }

  get getRevisionTecnica(): number {
    return this.listaKPis.find(kpi => kpi.codigo === "conductores_revisiontecnica")?.valor;
  }

  // get getNoDisponible(): number {
  //   return this.listaKPis.find(kpi => kpi.codigo === "conductores_nodisponible")?.valor;
  // }

  get getJornadaTerminada(): number {
    return this.listaKPis.find(kpi => kpi.codigo === "conductores_fuerajornada")?.valor;
  }

  filtrarPorKPI(kpi: KpiDTO) {
    // this.selectedKpiCode = kpi.codigo;
    if (this.kpiSelected && this.kpiSelected.codigo == kpi.codigo)
      this.kpiSelected = undefined;
    else
      this.kpiSelected = kpi;

    this.page = 0;
    this.estadoConductor = [];
    this.getListaConductores(true);
  }

  // get listaDeConductoresFiltrada(): ConductorDTO[] {
  //   return this.listaConductores.filter(conductor => {
  //   const coincideBusqueda = this.textoBusqueda.trim() === '' || (
  //   conductor.nombres?.toLowerCase().includes(this.textoBusqueda.toLowerCase()) ||
  //   conductor.apellidoMaterno?.toLowerCase().includes(this.textoBusqueda.toLowerCase()) ||
  //   conductor.apellidoPaterno?.toLowerCase().includes(this.textoBusqueda.toLowerCase()) ||
  //   conductor.visibleId?.toLocaleLowerCase().includes(this.textoBusqueda.toLocaleLowerCase()));
  //   const coincideEstado = this.estadoConductor === 'Todos' ||
  //   conductor.estado === this.estadoConductor;
  //   const coincideSucursal = this.sucursalConductor === 'Todos' ||
  //   conductor.contratoSucursal.codigo === this.sucursalConductor;
  //   const coincideHH = this.mostrarSoloHH === false ||
  //   this.mostrarSoloHH === conductor.hhExtraAutorizadas;
  // return coincideEstado; coincideBusqueda &&  && coincideHH && coincideSucursal;
  //   });
  // }

  formatHoraInicioReal(jornada: JornadaEnCursoDTO): string {

    if (!jornada) return '--';
    if (!jornada.fechaHoraInicio) return "--"

    const fecha = moment.utc(jornada.fechaHoraInicio).local();
    if (!fecha.isValid()) return "--";

    return fecha.format("HH:mm");
  }

  formatHoraInicioPlanificado(jornada: JornadaEnCursoDTO): string {

    if (!jornada) return '--';
    if (!jornada.fechaInicioPlanificado) return "--"

    const fecha = moment.utc(jornada.fechaInicioPlanificado).local();
    if (!fecha.isValid()) return "--";

    return fecha.format("HH:mm");
  }

  formatHoraFinReal(jornada: JornadaEnCursoDTO): string {

    if (!jornada) return '--';
    if (!jornada.fechaHoraTermino) return "--"

    const fecha = moment.utc(jornada.fechaHoraTermino).local();
    if (!fecha.isValid()) return "--";

    return fecha.format("HH:mm");
  }

  formatHoraFinPlanificado(jornada: JornadaEnCursoDTO): string {

    if (!jornada) return '--';
    if (!jornada.fechaTerminoPlanificado) return "--"

    const fecha = moment.utc(jornada.fechaTerminoPlanificado).local();
    if (!fecha.isValid()) return "--";

    return fecha.format("HH:mm");
  }

  tiempoDisponible(jornada: JornadaEnCursoDTO | null | undefined): string {
    if (!jornada) return "--";
  
    const minutosTotales = jornada.minutosRestantes;
  
    // nulo/indefinido/no numérico
    if (minutosTotales == null || typeof minutosTotales !== "number" || Number.isNaN(minutosTotales)) {
      return "--";
    }
  
    // negativo
    if (minutosTotales < 0) return "--";
  
    // exactamente cero
    if (minutosTotales === 0) return "00:00";
  
    const horas = Math.floor(minutosTotales / 60);
    const minutos = minutosTotales % 60;
  
    return `${this.pad(horas)}:${this.pad(minutos)}`;
  }

  horaColacion(jornada: JornadaEnCursoDTO) {
    const inicioColacion = moment.utc(jornada.colacionFechaInicioReal).local();
    if (!inicioColacion.isValid()) {
      return "--";
    }
    return inicioColacion.format("HH:mm");
  }

  formatoTipoContrato(tipoContrato: string) {
    if (tipoContrato === "FULL_TIME") return "FT";
    if (tipoContrato === "PART_TIME") return "PT";
    if (tipoContrato === "OTRO") return "O";
    return tipoContrato;
  }

  /*
   indicadores de filtros
  */
  // get cantidadTodosLosEstados(): number {
  //   return this.listaConductores.length;
  // }

  // get cantidadDisponibles(): number {
  //   return this.listaConductores.filter(conductor => conductor.estado === 'DISPONIBLE').length;
  // }

  // get cantidadEnCurso(): number {
  //   return this.listaConductores.filter(conductor => conductor.estado === 'EN_CURSO').length;
  // }

  // get cantidadEnPatio(): number {
  //   return this.listaConductores.filter(conductor => conductor.estado === 'EN_PATIO').length;
  // }

  // get cantidadEnColacion(): number {
  //   return this.listaConductores.filter(conductor => conductor.estado === 'EN_COLACION').length;
  // }

  // get cantidadEnRevTecnica(): number {
  //   return this.listaConductores.filter(conductor => conductor.estado === 'REVISION_TECNICA').length;
  // }

  // get cantidadNoDisponible(): number {
  //   return this.listaConductores.filter(conductor => conductor.estado === 'NO_DISPONIBLE').length;
  // }

  // get cantidadFueraJornada(): number {
  //   return this.listaConductores.filter(conductor => conductor.estado === 'FUERA_JORNADA').length;
  // }

  // actualizarCantidades() {
  //   this.cantidadPorSucursal = {};
  //   for (const conductor of this.listaConductores) {
  //     const cod = conductor.contratoSucursal.codigo;
  //     this.cantidadPorSucursal[cod] = (this.cantidadPorSucursal[cod] || 0) + 1;
  //   }
  // }

  actualizarTiemposOperativos(): void {
    this.listaConductores.forEach(conductor => {
      this.tiemposOperativos[conductor.uuid] = this.muestraTiempoOperativo(conductor?.estadoFechaInicio);
    });
  }

  muestraTiempoOperativo(fechaInicioEstado: string): string {
    if (!fechaInicioEstado) return '';

    const fechaAhora = moment.utc();
    const fechaInicio = moment.utc(fechaInicioEstado);
    const duracion = moment.duration(fechaAhora.diff(fechaInicio));

    const horas = Math.floor(duracion.asHours());
    const minutos = duracion.minutes();

    return `${this.pad(horas)}:${this.pad(minutos)}`;
  }

  formatoHorasExtras(minutos: number) {
    const hours = Math.floor(minutos / 60);
    const mins = minutos % 60;
    return `${this.pad(hours)}:${this.pad(mins)}`;
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  objectKeys(obj) {
    return Object.keys(obj);
  }

  actualizarCantidadEstados() {
    this.cantidadEstadoConductor = {};

    for (let key of this.objectKeys(this.ESTADOS_GESTION_CONDUCTOR)) {
      this.cantidadEstadoConductor[key] = key === 'TODOS'
        ? this.listaConductores.length
        : this.listaConductores.filter(conductor => conductor.estado === key).length;
    }
  }

  cercanoATerminarJornada(conductor: ConductorDTO) {

    const umbralConductorProxTerminar = environment.umbrales.conductorProxTerminar;
    if (
      !conductor ||
      !conductor.jornadaEnCurso ||
      !conductor.jornadaEnCurso.fechaTerminoPlanificado
    ) {
      return false;
    }

    const fechaTermino = moment.utc(conductor.jornadaEnCurso.fechaTerminoPlanificado).local();
    const ahora = moment.now();
    const diferenciaEnMinutos = fechaTermino.diff(ahora, 'minutes');
    return diferenciaEnMinutos >= 0 && diferenciaEnMinutos <= umbralConductorProxTerminar;
  }

  isConductorhoraExtraSobreHoraPlanificada(conductor: ConductorDTO): boolean {
    const umbral = environment.umbrales.horaExtraSobreHoraPlanificada;
    const fechaTermino = moment.utc(conductor.jornadaEnCurso?.fechaTerminoPlanificado);
    const fechaActual = moment.utc();

    if (!fechaTermino.isValid()) {
      return false;
    }

    const diferenciaMinutos = fechaActual.diff(fechaTermino, 'minutes');

    if (!fechaActual.isAfter(fechaTermino)) {
      return false;
    }

    if (diferenciaMinutos < umbral) {
      return false;
    }

    return true;
  }

  // getFinJornadaPDF(uuidJornada: string) {
  //   if (!uuidJornada)
  //     return;

  //   this.procesandoPdf = true;
  //   this.apiService.getFinJornadaPDF(uuidJornada).subscribe(
  //     (resp) => this.getFinJornadaPDFSuccess(resp),
  //     (error) => this.getFinJornadaPDFError(error)
  //   );
  // }

  // getFinJornadaPDFSuccess(pdfDTO: PdfDTO,) {
  //   console.log('exito pdf');
  //   this.procesandoPdf = false;
  //   if (pdfDTO.base64Content)
  //     pdfDTO.generatePdfFromBase64();
  //   else
  //     this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, 'Éxito');
  //   // this.alertService.presentAlertaInfo(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`);
  // }

  // getFinJornadaPDFError(error: HttpErrorResponse) {
  //   console.log('error kpis', error);
  //   this.procesandoPdf = false;
  //   const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
  //   //alert(msg);
  //   // this.toastr.error(msg, 'Error');
  //   this.alertService.presentAlertaError(msg, error);
  // }

  getEstadosSeleccionados() {
    let arregloSelected: Array<string> = [];
    this.estadoConductor.forEach((estado) => {
      arregloSelected.push(this.ESTADOS_GESTION_CONDUCTOR[estado]);
    });

    return arregloSelected.join(',');
  }

  convertirMinutosEnHoras(minutos: number) {
    if(!minutos || minutos == 0)
      return '00:00';

    return moment.duration(minutos * 60 * 1000).format("HH:mm");
  }
}
